<template>
    <div class="equal-prices">
        <subscriptions-equal-prices-group
            v-for="(group, idx) in priceGroups"
            :key="idx"
            :price-group-idx="idx"
            :group-id="groupId"
            :promotion="promotion"
            :preview-type="previewType"
            :show-price-lowest="showPriceLowest"
            :show-price-lowest-discount="showPriceLowestDiscount"
        />
        <the-btn
            class="btn-outline-custom mt-4"
            v-if="isButtonAvailable"
            @click.native="addPriceGroup"
        ><a-icon icon="Plus"
            width="15px"
            height="15px"
            class="mr-2"
        />
            Dodaj ceny dla pozostałych sklepów
        </the-btn>
    </div>
</template>

<script>
import SubscriptionsEqualPricesGroup from '@/components/promotions/SubscriptionsEqualPricesGroup'

export default {
    props: {
        promotion: {
            type: Object,
            required: true
        },
        groupId: {
            type: Number,
            required: true
        },
        previewType: {
            type: String,
            default: ''
        },
        showPriceLowest: {
            type: Boolean,
            default: false
        },
        showPriceLowestDiscount: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        priceGroups() {
            return this.promotion.subscriptionsEqualPrices.priceGroups
        },
        isButtonAvailable() {
            /* Button should be available when last price group has at least one subscription checked and at least one unchecked */
            let showButton = false
            const lastPriceGroup = this.priceGroups[this.priceGroups.length - 1]
            const findCheckedSub = lastPriceGroup.find(el => el.checked)
            const findUncheckedSub = lastPriceGroup.find(el => !el.checked)
            if (findCheckedSub && findUncheckedSub) {
                showButton = true
            }
            return showButton
        }
    },
    methods: {
        addPriceGroup() {
            this.$store.dispatch('addPriceGroup', {
                promoId: this.promotion.id,
                promotion: this.promotion,
                groupId: this.promotion.groupId,
                previewType: this.previewType
            })
        }
    },
    components: {
        SubscriptionsEqualPricesGroup
    }
}
</script>
